<template>
  <form @submit.prevent.stop="submitHandler">
    <Fieldset :disabled="disabled">
      <Row class="align-baseline" justify="end">
        <Col class="12 col-sm-9 col-md-8 d-flex align-baseline">
          <span class="text-paragraph-1 mr-3">www.</span>
          <TextField
            v-model="domain.subdomain"
            required
            :placeholder="lc.fields.subdomain.placeholder"
            :errorMessages="subdomainErrors"
            v-on="bindTouchEvents('subdomain')"
          />
        </Col>
        <Col cols="12 col-sm-3 col-md-2">
          <SelectField
            v-model="domain.tld"
            required
            :items="domainTlds"
            :errorMessages="tldErrors"
            v-on="bindTouchEvents('tld')"
            :readonly="loading"
          />
        </Col>
        <Col cols="12 col-sm-12 col-md-2">
          <Button
            :label="lc.submitButton.label"
            large
            block
            color="primary"
            type="submit"
          />
        </Col>
      </Row>
    </Fieldset>
  </form>
</template>

<script>
import { computed, onBeforeMount, watch } from 'vue'
import { Row, Col, Fieldset, TextField, SelectField, Button, useLocale, useValidation } from '@locaweb/design-system-vue'
import useTlds from '@/composables/api/useTlds'
import Domain from '@/models/domain'
import FormValidation from '@/mixin/FormValidation'

export default {
  name: 'DomainForm',
  components: {
    Row,
    Col,
    Fieldset,
    TextField,
    SelectField,
    Button
  },
  mixins: [FormValidation({ dataKey: 'domain' })],
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    serverError: {
      type: String,
      required: false
    }
  },
  setup (_, { emit }) {
    const $v = useValidation()
    const lc = useLocale('domains.addDomain.domainForm')
    const { data, execute: executeFetch, loading } = useTlds()
    const domain = Domain.model

    function replaceSubdomain () {
      const newDomain = domain.value.subdomain.replace(/^www/, '')
      domain.value.subdomain = newDomain
    }

    function submitHandler () {
      $v.value.domain.$touch()

      if (!$v.value.domain.$invalid) {
        replaceSubdomain()
        emit('submit', domain.value)
      }
    }

    const domainTlds = computed(() => data?.value?.tlds || [])

    onBeforeMount(async () => await executeFetch())

    watch(domain.value, () => emit('cleanServerError'))

    return { domainTlds, loading, domain, lc, submitHandler, replaceSubdomain }
  },
  validations: Domain.validations,
  computed: {
    ...Domain.validationErrors
  }
}
</script>
